import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Icon, Select } from 'antd'
import { action, observable } from 'mobx'
import { popup } from './style.scss'
import { users } from '@services/api'

@inject((store: any) => {
    const { popupStore, companiesStore } = store
    return { popupStore, companiesStore }
})
@observer
class AddClientDataPopup extends Component<any, any> {
    state: any = {
        status: 'INCOMPLETE'
    }
    @observable loading = false
    @observable hmo = this.props.companiesStore.hmoNames[0]
    @observable hmoPlan = {}
    @observable hmoPlanList = []

    async componentDidMount() {
        await this.getHmoPlans()
    }

    getHmoPlans = async () => {
        await this.props.companiesStore.getHmoWithPlansList()
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    changeStatus() {
        this.setState({ status: 'COMPLETE' })
    }

    saveData = async () => {
        const { clientId } = this.props

        await users.updateUserHmoPlans({ id: clientId, hmo_id: this.hmo, hmo_plan_id: this.hmoPlan })
        this.changeStatus()
    }
    @action
    onChangeHmo = value => {
        const { hmoPlansList } = this.props.companiesStore
        this.hmo = value
        this.hmoPlanList = JSON.parse(JSON.stringify(hmoPlansList.filter(obj => obj.id === value)[0]['plans']))
    }
    @action
    onChangeHmoPlan = value => {
        this.hmoPlan = value
    }

    render() {
        const { Option } = Select

        const {
            popupStore,
            title,
            clientId,

            companiesStore: { hmoNames }
        } = this.props

        const showSelects =
            this.state.status === 'COMPLETE' ? (
                <span> צריך רק להעלות קובץ </span>
            ) : (
                <div>
                    <Select
                        placeholder="בחר/י קופת חולים"
                        style={{ width: 150 }}
                        onChange={value => this.onChangeHmo(value)}
                    >
                        {hmoNames.map(item => {
                            return (
                                <Option key={item.id} value={item['id']}>
                                    {item.name}
                                </Option>
                            )
                        })}
                    </Select>
                    <Select
                        placeholder="בחר/י כרטיס קופת חולים"
                        style={{ width: 250 }}
                        onChange={value => this.onChangeHmoPlan(value)}
                    >
                        {this.hmoPlanList.map(item => {
                            return (
                                <Option key={item.id} value={item['id']}>
                                    {item.name}
                                </Option>
                            )
                        })}
                    </Select>
                </div>
            )

        const footerButtons = (
            <div
                className={popup}
                style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}
            >
                <Button
                    onClick={() =>
                        popupStore.togglePopup('uploadFile', {
                            bucket: 'clients',
                            related: clientId,
                            types: ['doc']
                        })
                    }
                    disabled={this.state.status !== 'COMPLETE'}
                >
                    <Icon type="upload" />
                </Button>
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>סגור</Button>
                    <Button type="primary" onClick={this.saveData}>
                        שמירת נתונים
                    </Button>
                </div>
            </div>
        )

        return (
            <Modal
                title={title}
                visible={popupStore.popupType === 'addClientData'}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                {showSelects}
            </Modal>
        )
    }
}

export default withRouter(AddClientDataPopup)
